import 'styles/powysPASearch.scss'
import {Urls} from '../constants'
// import "../base/paSearch.js"
import { cym } from "../utils/cymTranslation.js";
import { pagination } from "../utils/pagination.js";
// import moment from 'moment';
// import { loader } from "../utils/loader.js";
// import { displayDateTime } from "../utils/displayDateTime.js";

(function () {
    /* global $ */
    "use strict";

    let currentState = {
        attributes: '',
		page: 1,
		pageCount: 1,
		ItemsPerPage: '12',
		SortColumn: 'TransactionDate',
		SortType: 'asc',
		search: ''
	}

    function findPATranslation(){
        if ( localStorage.getItem('language') === 'cym') {                        
            cym('Find a PA', 'Dod o hyd i Gynorthwy-ydd Personol');
            cym('Home', 'Hafan')

            cym('Location', 'Lleoliad '); 
            cym('Brecon', 'Aberhonddu'); 
            cym('Builth Wells and Llanwrtyd Wells', 'Llanfair ym Muallt a Llanwrtyd'); 
            cym('Crickhowell', 'Crucywel'); 
            cym('Hay on Wye and Talgarth', 'Y Gelli Gandryll a Thalgarth'); 
            cym('Knighton and Presteigne', 'Trefyclo a Llanandras'); 
            cym('Llandrindod and Rhayader', 'Llandrindod a Rhaeadr Gwy'); 
            cym('Llanfair Caereinion','Llanfair Caereinion')
            cym('Llanfyllin','Llanfyllin')
            cym('Llanidloes','Llanidloes')
            cym('Machynlleth','Machynlleth')
            cym('Newtown', 'Y Drenewydd'); 
            cym('Welshpool and Montgomery', 'Y Trallwng a Threfaldwyn'); 
            cym('Ystradgynlais','Ystradgynlais')

            cym('Employable personal assistant','Cynorthwyydd personol cyflogadwy');
            cym('Self employed Personal assistant','Cynorthwyydd personol hunangyflogedig')
            cym('sole trader','masnachwr unigol')
            cym('Micro Enterprise member','Aelod Menter ficro');
            cym('Micro enterprise with employees','Menter ficro gyda gweithwyr');
            cym('Not CIW registered','Heb ei gofrestru gan AGC');

            cym('CIW registered domiciliary care agency','Asiantaeth gofal cartref cofrestredig gan AGC');

            cym('Requirements', 'Gofynion');
            cym('Basic First Aid Training','Hyfforddiant Cymorth Cyntaf Sylfaenol')
            cym('CIW registered', 'Cofrestrwyd gydag Arolygiaeth Gofal Cymru');
            cym('Cover arranged for A/L', `Cyflenwi wedi'i drefnu ar gyfer Gwyliau blynyddol`);
            cym('Cover arranged for sickness', `Cyflenwi wedi'i drefnu ar gyfer salwch`);
            cym('DBS provided', `DBS wedi'i ddarparu`);
            cym('Food hygiene Training', 'Hyfforddiant hylendid bwyd');
            cym('HMRC registered', 'Wedi cofrestru gyda CThEF');
            cym('Insurance included', `Yswiriant wedi'i gynnwys`);
            cym('IT literate/Digitally confident', 'Yn llythrennog mewn TG/Yn ddigidol hyderus');
            cym('Manual handling Training', 'Hyfforddiant codi a chario');
            cym('Medication Training', 'Hyfforddiant Meddyginiaeth');
            cym('Personal care Training', 'Hyfforddiant Gofal personol');
            cym('Policies/risk assessments/support plans', 'Polisïau/asesiadau risg/cynlluniau cymorth');
            cym('References available', 'Geirdaon ar gael');
            cym('Safeguarding Training', 'Hyfforddiant Diogelu');
            cym('SCW registered', 'Wedi cofrestru gyda Gofal Cymdeithasol Cymru');
            cym('Uniform provided', 'Darperir gwisg '); 
            cym('Willing to drive DP user car','Yn fodlon gyrru car y Derbynnydd Taliad Uniongyrchol')
            cym('Willing to use PA car','Yn fodlon defnyddio car y Cynorthwy-ydd Personol')

            cym('Availability needed', 'Argaeledd sydd ei angen'); 
            cym('Monday', 'Dydd Llun'); 
            cym('Tuesday', 'Dydd Mawrth'); 
            cym('Wednesday', 'Dydd Mercher'); 
            cym('Thursday', 'Dydd Iau'); 
            cym('Friday', 'Dydd Gwener'); 
            cym('Saturday', 'Dydd Sadwrn'); 
            cym('Sunday', 'Dydd Sul'); 
            cym('Term Time', 'Yn Ystod y Tymor'); 
            cym('School Holidays', 'Gwyliau’r Ysgol'); 

            cym('Hourly Rate','Cyflog yr awr')
            cym('£12.60 PA gross','£12.60 gros yr awr i CP');
            cym('£15.83 Self-employed gross','£15.83 Hunan gyflogedig');
            cym('£27.02 Agency','£27.02 Asiantaeth');
            cym('£43 Sleep-in','£43.00 Cysgu ar safle');
            cym('Other - to be discussed','Arall: i’w drafod');

            cym('Languages', 'Ieithoedd');
            cym('English', 'Saesneg');
            cym('Welsh', 'Cymraeg');
            // cym('Provider Type', 'math darparwr');

            cym('Provider Type', 'Math o Ddarparwr'); 
            // cym('CIC','Gofal Integredig Cymunedol')
            // cym('Registered Care Provider', 'Darparwr Gofal Cofrestredig');
            // cym('Self Employed - Micro-enterprise', 'Hunangyflogedig - Micro-fenter');
            // cym('Self Employed - Small Organisation', 'Hunangyflogedig - Sefydliad Bach');
            // cym('Self Employed - Sole Trader', 'Hunangyflogedig - Unig Fasnachwr');
            // cym('Social Firm/Social Enterprise', 'Cwmni Cymdeithasol/Menter Gymdeithasol');
            // cym('Unregistered Provider', 'Darparwr Anghofrestredig');
            
            
            // cym('Help', 'Cymorth');
            cym('Results', 'Canlyniad');
            cym('Sort by', 'Trefnu yn ôl');
            cym('Relevance', 'Perthnasedd');
            // cym('Name (A - Z)', 'Enw ( A- Y)');
            // cym('Name (Z - A)', 'Enw (Y-A)');  

            cym('What these mean',`Beth mae'r rhain yn ei olygu`)

            cym('These are the places PAs are willing to travel for work', `Dyma'r lleoedd y mae Cynorthwywyr Personol yn fodlon teithio iddynt i weithio`);
            cym('These are attributes the PA must obtain to be considered', `Mae'r rhain yn nodweddion y mae'n rhaid i'r Cynorthwywyr Personol eu meddu i gael eu hystyried`);
            // cym('CIW', 'CIW')
            cym('Care Inspectorate Wales', 'Arolygiaeth Gofal Cymru')
            // cym('A/L', 'A/L')
            cym('Annual leave', 'Gwyliau blynyddol')
            // cym('DBS', 'Gwasanaeth Datgelu a Gwahardd')
            cym('Disclosure and Barring Service', 'Gwasanaeth Datgelu a Gwahardd')
            // cym(`HMRC`, 'Treth Incwm, Hunanasesiad a mwy')
            cym(`His Majesty's Revenue and Customs`, 'Cyllid a Thollau Ei Fawrhydi')
            // cym(`SCW`, 'Gofal Cymdeithasol Cymru')
            cym(`Social Care Wales`, 'Gofal Cymdeithasol Cymru')
            
            cym(`Direct Payment Recipient`, 'Derbynnydd Taliad Uniongyrchol')
            cym(`Personal Assistant`, 'Cynorthwy-ydd Personol')
            cym(`Availability needed`, 'Argaeledd sydd ei angen')
            cym(`These are the days/times the PA must be available`, `Dyma'r dyddiau/amseroedd y mae'n rhaid i'r Cynorthwy-ydd Personol fod ar gael`)
            cym(`These are the languages the PA must speak`, `Dyma'r ieithoedd y mae'n rhaid i'r Cynorthwy-ydd Personol eu siarad`)
            // cym(`Provider type`, 'Math o ddarparwr')
            cym(`These are the type of provider the DP is looking for`, `Dyma'r math o ddarparwr y mae'r Unigolyn Dibynnol yn chwilio amdano`)
            cym(`Community Integrated Care`, 'Gofal Integredig Cymunedol')
        }
    }

    async function getPAListDetails() {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/Event/GetEventsList`);
        
        endpoint.searchParams.set('attrValue', currentState.attributes);
        endpoint.searchParams.set('templateId', siteConstants.paTemplate);
		endpoint.searchParams.set('orgId', siteConstants.orgId);
        endpoint.searchParams.set('search', currentState.search);
        endpoint.searchParams.set('page', currentState.page);
        endpoint.searchParams.set('itemsPerPage', currentState.ItemsPerPage);
        endpoint.searchParams.set('fields', 'Id,Name,DetailsImageUrl,Description,Address,Postcode,Phone,Email,Website,Attributes,CustomFieldName,CustomFieldUpdateDate,CustomFieldValue');
        endpoint.searchParams.set('isFullPhraseMatch', 'true');
        endpoint.searchParams.set('SortType', currentState.SortType);

		const response = await fetch(endpoint);
		const data = await response.json();
		return data;
	}

    async function getVacanciesListEndpoint() {
		// const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/Event/GetEventsJson`);
        const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/Event/GetEventsList`);
        
        endpoint.searchParams.set('attrValue', currentState.attributes);
        endpoint.searchParams.set('templateId', siteConstants.paTemplate);
		endpoint.searchParams.set('orgId', siteConstants.orgId);
        endpoint.searchParams.set('search', currentState.search);
        endpoint.searchParams.set('page', currentState.page);
        endpoint.searchParams.set('itemsPerPage', currentState.ItemsPerPage);
        endpoint.searchParams.set('fields', 'Id,Name,DetailsImageUrl,Description,Address,Postcode,Phone,Email,Website,Attributes,CustomFieldName,CustomFieldUpdateDate,CustomFieldValue');
        endpoint.searchParams.set('isFullPhraseMatch', 'true');
        endpoint.searchParams.set('SortType', currentState.SortType);

		const response = await fetch(endpoint);
		const data = await response.json();
        // console.log(data)
		return data;
	}


    function createPage() {
        // createDashboardHeader();
        createDashboardBody();
    }

    function overlay() {
		$('body').prepend(
			'<div class="js-overlay block" style="width: 100%; height: 100%; background-color: rgba(0,0,0,0.4); z-indeX: 100; position: fixed"></div>'
		);
	}

    function createDashboardBody(){

        $('.js-paSearch').append(
            `
            <div class="dashboard-body">
                <div class="dashboard-body__location-section">  
                    <span><a href="/s4s/CustomPage/Index/${Urls.homepage}">Home <i class="fas fa-angle-right"></i></a><h1 class="location-content">Find a PA</h1></span>
                </div>
                
                <div id="modalOverlay" class="overlay"></div>
                <div id="modal" class="modal" tabindex="0">
                  <div class="modal-content" tabindex="0">
                    <div class="modal-head">
                        <div class="modal-header">
                            <div class="icon-circle" >
                                <i class="fas fa-question"></i>
                            </div>
                            <h2 tabindex="0">What these mean</h2>
                        </div>
                        <button id="closeModalBtn" class="close" aria-label="Close" tabindex="0"><i class="fa fa-times"></i></button>
                    </div>
                    
                    <p><strong tabindex="0">Location</strong></p>
                    <p tabindex="0">These are the places PAs are willing to travel for work</p>
                    <br>
                    
                    <p><strong tabindex="0">Requirements</strong></p>
                    <p tabindex="0">These are attributes the PA must obtain to be considered</p>
                    <br>
                    
                    <p><strong tabindex="0">CIW</strong></p>
                    <p tabindex="0">Care Inspectorate Wales</p>
                    <br>

                    <p><strong tabindex="0">A/L</strong></p>
                    <p tabindex="0">Annual leave</p>
                    <br>

                    <p><strong tabindex="0">DBS</strong></p>
                    <p tabindex="0">Disclosure and Barring Service</p>
                    <br>

                    <p><strong tabindex="0">HMRC</strong></p>
                    <p tabindex="0">His Majesty's Revenue and Customs</p>
                    <br>

                    <p><strong tabindex="0">SCW</strong></p>
                    <p tabindex="0">Social Care Wales</p>
                    <br>

                    <p><strong tabindex="0">DP</strong></p>
                    <p tabindex="0">Direct Payment Recipient</p>
                    <br>

                    <p><strong tabindex="0">PA</strong></p>
                    <p tabindex="0">Personal Assistant</p>
                    <br>

                    <p><strong tabindex="0">Availability needed</strong></p>
                    <p tabindex="0">These are the days/times the PA must be available</p>
                    <br>

                    <p><strong tabindex="0">Languages</strong></p>
                    <p tabindex="0">These are the languages the PA must speak</p>
                    <br>

                    <p><strong tabindex="0">Provider Type</strong></p>
                    <p tabindex="0">These are the type of provider the DP is looking for</p>
                    <br>

                    <p><strong tabindex="0">CIC</strong></p>
                    <p tabindex="0">Community Integrated Care</p>
                                       
                    
                  </div>
                </div>
                <div class="dashboard-body__filter-section" id="dashboard-body__filter-section">
                    <div class="sort-container" role="navigation" aria-labelledby="filterLocation">
                        <h2 class="sr-only">Location</h2>
                        <button id="filterLocation" class="filterBtn"><span>Location<span class="filterCount"></span></span></button>
                        <div class="filters-container">
                            <div class="filters-container_filter">
                                <div class="attr-container">
                                    <ul id="filterLocationDropdown" class="dropdown">
                                        <li><button class="js-attr-btn" data-attr="427976e2-e16e-4246-8699-ac6300f5234f,"><span></span>Brecon</button></li>
                                        <li><button class="js-attr-btn" data-attr="1b2bad12-c41a-4d80-9a09-ac6300f5234f,"><span></span>Builth Wells and Llanwrtyd Wells</button></li>
                                        <li><button class="js-attr-btn" data-attr="53e05471-75a3-4d6e-8876-ac6300f5234f,"><span></span>Crickhowell</button></li>
                                        <li><button class="js-attr-btn" data-attr="afea8f27-c69c-43dc-8d8e-ac6300f5234f,"><span></span>Hay on Wye and Talgarth</button></li>
                                        <li><button class="js-attr-btn" data-attr="a6b3dad2-306c-40d3-8582-ac6300f5234f,"><span></span>Knighton and Presteigne</button></li>
                                        <li><button class="js-attr-btn" data-attr="719aa7bd-dd40-44e1-bb3b-ac6300f5234f,"><span></span>Llandrindod and Rhayader</button></li>
                                        <li><button class="js-attr-btn" data-attr="5c2cb965-92e2-4c8a-a7e3-ac6300f5234f,"><span></span>Llanfair Caereinion</button></li>
                                        <li><button class="js-attr-btn" data-attr="2b75e933-1cf3-4106-82f7-ac6300f5234f,"><span></span>Llanfyllin</button></li>
                                        <li><button class="js-attr-btn" data-attr="9d0dc52a-7510-4eeb-a83a-ac6300f5234f,"><span></span>Llanidloes</button></li>
                                        <li><button class="js-attr-btn" data-attr="3ec7e46b-0607-4414-b421-ac6300f5234f,"><span></span>Machynlleth</button></li>
                                        <li><button class="js-attr-btn" data-attr="db313647-d307-47c4-b6e8-ac6300f5234f,"><span></span>Newtown</button></li>
                                        <li><button class="js-attr-btn" data-attr="8c211b5e-c128-49bc-8e47-ac6300f5234f,"><span></span>Welshpool and Montgomery</button></li>
                                        <li><button class="js-attr-btn" data-attr="7c92e431-8a59-436a-814e-ac6300f5234f,"><span></span>Ystradgynlais</button></li>
                                        <li>
                                            <div id="openModalBtnLocation" class="openModalBtn" tabindex="0">
                                                <div class="icon-circle">
                                                    <i class="fas fa-question"></i>
                                                </div>
                                                <h2>What these mean</h2>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sort-container" role="navigation" aria-labelledby="filterRequirements">
                        <h2 class="sr-only">Requirements</h2>
                        <button id="filterRequirements" class="filterBtn"><span>Requirements<span class="filterCount"></span></span></button>
                        <div class="filters-container">
                            <div class="filters-container_filter">
                                <div class="attr-container">
                                    <ul id="filterRequirementsDropdown" class="dropdown">
                                        <li><button class="js-attr-btn" data-attr="ca9d5dd3-6afc-4302-8c07-b0d600a22174,"><span></span>Basic First Aid Training</button></li>
                                        <li><button class="js-attr-btn" data-attr="a6164a4f-5420-4894-b95f-b03600fb4683,"><span></span>CIW registered</button></li>
                                        <li><button class="js-attr-btn" data-attr="4669ce89-e165-450e-8cae-b03600fb4683,"><span></span>Cover arranged for A/L</button></li>
                                        <li><button class="js-attr-btn" data-attr="178f49bf-3b2e-4f09-8e24-b03600fb4683,"><span></span>Cover arranged for sickness</button></li>
                                        <li><button class="js-attr-btn" data-attr="ed29bf38-8a02-4407-a2cc-b03600fb4683,"><span></span>DBS provided</button></li>
                                        <li><button class="js-attr-btn" data-attr="833e29bf-3e7f-43f3-a1cc-b03600fb4683,"><span></span>Food hygiene Training</button></li>
                                        <li><button class="js-attr-btn" data-attr="5001c49d-e9ff-4424-9e9a-b03600fb4683,"><span></span>HMRC registered</button></li>
                                        <li><button class="js-attr-btn" data-attr="51629b51-ed21-4a94-83ef-b03600fb4683,"><span></span>Insurance included</button></li>
                                        <li><button class="js-attr-btn" data-attr="a5dafe77-b899-4023-be6e-b03600fb4683,"><span></span>IT literate/Digitally confident</button></li>
                                        <li><button class="js-attr-btn" data-attr="19a4cbd8-6758-4153-9a81-b03600fb4683,"><span></span>Manual handling Training</button></li>
                                        <li><button class="js-attr-btn" data-attr="8c78aa0b-a44c-49e2-9489-b03600fb4683,"><span></span>Medication Training</button></li>
                                        <li><button class="js-attr-btn" data-attr="e0a430fe-4386-4c3e-951a-b03600fb4683,"><span></span>Personal care Training</button></li>
                                        <li><button class="js-attr-btn" data-attr="4ccd3547-2005-48cb-9e3b-b03600fb4683,"><span></span>Policies/risk assessments/support plans</button></li>
                                        <li><button class="js-attr-btn" data-attr="0eb104b4-78fb-42b7-8228-b03600fb4683,"><span></span>References available</button></li>
                                        <li><button class="js-attr-btn" data-attr="e2a489fa-fede-42a5-a10e-b03600fb4683,"><span></span>Safeguarding Training</button></li>
                                        <li><button class="js-attr-btn" data-attr="15088807-111c-47f6-ae0c-b03600fb4683,"><span></span>SCW registered</button></li>
                                        <li><button class="js-attr-btn" data-attr="e50cd4a6-0b38-413b-bb7f-b03600fb4683,"><span></span>Uniform provided</button></li>
                                        <li><button class="js-attr-btn" data-attr="bd6c201d-538f-476a-a824-b03600fb4683,"><span></span>Willing to drive DP user car</button></li>
                                        <li><button class="js-attr-btn" data-attr="27d49dbd-14f6-4438-a14d-b03600fb4683,"><span></span>Willing to use PA car</button></li>
                                    
                                        <li>
                                            <div id="openModalBtnRequirements" class="openModalBtn" tabindex="0">
                                                <div class="icon-circle">
                                                    <i class="fas fa-question"></i>
                                                </div>
                                                <h2>What these mean</h2>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sort-container" role="navigation" aria-labelledby="filterAvailability">
                        <h2 class="sr-only">Availability</h2>
                        <button id="filterAvailability" class="filterBtn"><span>Availability needed<span class="filterCount"></span></span></button>
                        <div class="filters-container">
                            <div class="filters-container_filter">
                                <div class="attr-container">
                                    <ul id="filterAvailabilityDropdown" class="dropdown">
                                       
                                        <li><button class="js-attr-btn" data-attr="7c0e70ae-00b9-4b2c-8e88-ac6300f5bb13,"><span></span>Monday</button></li>
                                        <li><button class="js-attr-btn" data-attr="3d28142d-d5ac-4089-bc87-ac6300f5bb13,"><span></span>Tuesday</button></li>
                                        <li><button class="js-attr-btn" data-attr="03aed109-4781-440b-9e8e-ac6300f5bb13,"><span></span>Wednesday</button></li>
                                        <li><button class="js-attr-btn" data-attr="06d11c4c-c5c5-4003-b609-ac6300f5bb13,"><span></span>Thursday</button></li>
                                        <li><button class="js-attr-btn" data-attr="49bcab4d-1f9a-422d-9856-ac6300f5bb13,"><span></span>Friday</button></li>
                                        <li><button class="js-attr-btn" data-attr="ba1815d8-0a72-4553-b3a9-ac6300f5bb13,"><span></span>Saturday</button></li>
                                        <li><button class="js-attr-btn" data-attr="8b827264-4c99-410c-950e-ac6300f5bb13,"><span></span>Sunday</button></li>
                                        <li><button class="js-attr-btn" data-attr="bc8046f6-fcd5-48aa-95a2-ac6300f5bb13,"><span></span>School Holidays</button></li>
                                        <li><button class="js-attr-btn" data-attr="a383ae52-82bd-43a4-8618-ac6300f5bb13,"><span></span>Term Time</button></li>                                      
                                        
                                        <li>
                                            <div id="openModalBtnAvailability" class="openModalBtn" tabindex="0">
                                                <div class="icon-circle">
                                                    <i class="fas fa-question"></i>
                                                </div>
                                                <h2>What these mean</h2>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sort-container" role="navigation" aria-labelledby="filterLanguages">
                        <h2 class="sr-only">Languages</h2>
                        <button id="filterLanguages" class="filterBtn"><span>Languages<span class="filterCount"></span></span></button>
                        <div class="filters-container">
                            <div class="filters-container_filter">
                                <div class="attr-container">
                                    <ul id="filterLanguagesDropdown" class="dropdown">
                                        <li><button class="js-attr-btn" data-attr="820fe14b-55f6-490b-a3b3-ac6300f943c0,"><span></span>English</button></li>
                                        <li><button class="js-attr-btn" data-attr="2df0f81e-0cd8-4947-af7b-ac6300f943c0,"><span></span>Welsh</button></li>
                                        
                                        <li>
                                            <div id="openModalBtnLanguages" class="openModalBtn" tabindex="0">
                                                <div class="icon-circle">
                                                    <i class="fas fa-question"></i>
                                                </div>
                                                <h2>What these mean</h2>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sort-container" role="navigation" aria-labelledby="filterProviderType">
                        <h2 class="sr-only">Provider Type</h2>
                        <button id="filterProviderType" class="filterBtn" ><span>Provider Type<span class="filterCount"></span></span></button>
                        <div class="filters-container">
                            <div class="filters-container_filter">
                                <div class="attr-container">
                                    <ul id="filterProviderTypeDropdown" class="dropdown">
                                        <li><button class="js-attr-btn" data-attr="4b6b9b11-92f9-48bb-83ec-accd00b856e7,"><span></span>CIW registered domiciliary care agency</button></li>
                                        <li><button class="js-attr-btn" data-attr="32d82cba-92b4-4fab-b176-b23400efa836,"><span></span>Employable personal assistant</button></li>
                                        <li><button class="js-attr-btn" data-attr="81efedf1-b480-4a5b-ada5-accd00b856e7,"><span></span>Micro enterprise with employees (Not CIW registered)</button></li>
                                        <li><button class="js-attr-btn" data-attr="71c09460-a6a4-4a54-aa36-b23400efa836,"><span></span>Micro Enterprise member</button></li>
                                        <li><button class="js-attr-btn" data-attr="85eebd3c-5068-4299-ac71-b23400efa836,"><span></span>Self employed Personal assistant (sole trader)</button></li>
                                                                            
                                        <li>
                                            <div id="openModalBtnProviderType" class="openModalBtn" tabindex="0">
                                                <div class="icon-circle">
                                                    <i class="fas fa-question"></i>
                                                </div>
                                                <h2>What these mean</h2>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="sort-container" role="navigation" aria-labelledby="filterHourlyRate">
                        <h2 class="sr-only">Hourly Rate</h2>
                        <button id="filterHourlyRate" class="filterBtn" ><span>Hourly Rate<span class="filterCount"></span></span></button>
                        <div class="filters-container">
                            <div class="filters-container_filter">
                                <div class="attr-container">
                                    <ul id="filterHourlyRateDropdown" class="dropdown">
                                        <li><button class="js-attr-btn" data-attr="a331dbc5-1aac-47e9-a481-b34e00c631f9,"><span></span>£12.60 PA gross</button></li>
                                        <li><button class="js-attr-btn" data-attr="28b70c74-c816-4dde-89cd-b34e00c631f9,"><span></span>£15.83 Self-employed gross</button></li>
                                        <li><button class="js-attr-btn" data-attr="f560983e-c35c-44ef-a5c0-b34e00c631f9,"><span></span>£27.02 Agency</button></li>
                                        <li><button class="js-attr-btn" data-attr="324a7a16-8387-463d-bd76-b34e00c631f9,"><span></span>£43 Sleep-in</button></li>
                                        <li><button class="js-attr-btn" data-attr="ec261dfa-e73f-46da-b8e6-b34e00c631f9,"><span></span>Other - to be discussed</button></li>
                                                                            
                                        <li>
                                            <div id="openModalBtnHourlyRate" class="openModalBtn" tabindex="0">
                                                <div class="icon-circle">
                                                    <i class="fas fa-question"></i>
                                                </div>
                                                <h2>What these mean</h2>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               

                <div class="dashboard-body__list-section" id="dashboard-body__list-section">
                        <div class="dashboard-body__sort-section">
                            <div class="dashboard-body__sort-results js-dashboard-body__sort-results" tabindex="0" role="status"></div>
                            <div class="dashboard-body__sort-by" tabindex="0">
                                <div class="sort-container">
                                    <label for="js-sorting-events" tabindex="0"> Sort by:</label>
                                    <select name="" id="js-sorting-events" tabindex="0">
                                        <option value="" title="Sort by relevance" tabindex="0">Relevance</option>
                                        <option value="js-sort-name-a-z" title="Sort by name (A - Z)" tabindex="0">Name (A - Z)</option>
                                        <option value="js-sort-name-z-a" title="Sort by name (Z - A)" tabindex="0">Name (Z - A)</option>
                                    </select></div>
                            </div>
                        </div>
                        <div class="dashboard-body__tile">
                            <ul class="js-vacancies--list"></ul>
                            <div class="js-pagination__container"></div>
                        </div>
                    </div>

            </div>
            `
        )

        createMyVacanciesPanel();
    }

    // getVacanciesListEndpoint()
     
                    
    async function createMyPAListDetails() {
        const getPADetails = await getPAListDetails();
        const getPAArrayDetails = getPADetails.Items;
    
        const newPADetailsArray = [];
    
        if (getPAArrayDetails !== null) {
            getPAArrayDetails.forEach(function (pa) {
                const idObject = { 'id': `${pa.Id}`, 'attributes': [] }; // Create the 'id' object with an empty 'attributes' array
    
                
                // Create a map to specify the desired order for attributes
                const attributeOrder = {
                    'DBS provided': 1,
                    'Insurance included': 2,
                    'HMRC registered': 3,
                };
    
                for (let i = 0; i < pa.AttributeValues.length; i++) {
                    const attributeValue = pa.AttributeValues[i];
    
                    if (attributeValue === 'a6164a4f-5420-4894-b95f-b03600fb4683') {
                        idObject.attributes.push('CIW registered');
                    } else if (attributeValue === '4669ce89-e165-450e-8cae-b03600fb4683') {
                        idObject.attributes.push('Cover arranged for A/L');
                    } else if (attributeValue === '178f49bf-3b2e-4f09-8e24-b03600fb4683') {
                        idObject.attributes.push('Cover arranged for sickness');
                    } else if (attributeValue === 'ed29bf38-8a02-4407-a2cc-b03600fb4683') {
                        idObject.attributes.push('DBS provided');
                    } else if (attributeValue === '833e29bf-3e7f-43f3-a1cc-b03600fb4683') {
                        idObject.attributes.push('Food hygiene Training');
                    } else if (attributeValue === '5001c49d-e9ff-4424-9e9a-b03600fb4683') {
                        idObject.attributes.push('HMRC registered');
                    } else if (attributeValue === '51629b51-ed21-4a94-83ef-b03600fb4683') {
                        idObject.attributes.push('Insurance included');
                    } else if (attributeValue === 'a5dafe77-b899-4023-be6e-b03600fb4683') {
                        idObject.attributes.push('IT literate/Digitally confident');
                    } else if (attributeValue === '19a4cbd8-6758-4153-9a81-b03600fb4683') {
                        idObject.attributes.push('Manual handling Training');
                    } else if (attributeValue === '8c78aa0b-a44c-49e2-9489-b03600fb4683') {
                        idObject.attributes.push('Medication Training');
                    } else if (attributeValue === 'e0a430fe-4386-4c3e-951a-b03600fb4683') {
                        idObject.attributes.push('Personal care Training');
                    } else if (attributeValue === '4ccd3547-2005-48cb-9e3b-b03600fb4683') {
                        idObject.attributes.push('Policies/risk assessments/support plans');
                    } else if (attributeValue === '0eb104b4-78fb-42b7-8228-b03600fb4683') {
                        idObject.attributes.push('References available');
                    } else if (attributeValue === 'e2a489fa-fede-42a5-a10e-b03600fb4683') {
                        idObject.attributes.push('Safeguarding Training');
                    } else if (attributeValue === '15088807-111c-47f6-ae0c-b03600fb4683') {
                        idObject.attributes.push('SCW registered');
                    } else if (attributeValue === 'e50cd4a6-0b38-413b-bb7f-b03600fb4683') {
                        idObject.attributes.push('Uniform provided');
                    } else if (attributeValue === 'bd6c201d-538f-476a-a824-b03600fb4683') {
                        idObject.attributes.push('Willing to drive DP user car');
                    } else if (attributeValue === '27d49dbd-14f6-4438-a14d-b03600fb4683') {
                        idObject.attributes.push('Willing to use PA car');
                    }
    
                }
    
                // Sort the attributes based on the desired order
                idObject.attributes.sort((a, b) => {
                    return (attributeOrder[a] || Number.MAX_SAFE_INTEGER) - (attributeOrder[b] || Number.MAX_SAFE_INTEGER);
                });

                 // Keep only the first 3 attributes if there are more than 3
                idObject.attributes = idObject.attributes.slice(0, 3);
    
                if (idObject.attributes.length > 0) {
                    newPADetailsArray.push(idObject); // Add the 'id' object to the result array if there are attributes
                }
            });
        }
    
        if (newPADetailsArray.length > 0) {
            return newPADetailsArray;
        } else {
            return []; // Return an empty array if there are no results
        }
    }               
          
        
    
    async function createMyVacanciesPanel() {
        const getVacancies = await getVacanciesListEndpoint();
        const getVacanciesArray = getVacancies.Items;
        const newPADetailsArray = [];
    
        $('.js-overlay').remove();

        if (localStorage.getItem('language') === 'cym') {
            if(getVacancies.Paging.TotalItemsCount === 0) {
                $('.js-dashboard-body__sort-results').html('Dim canlyniadau')
            } else if(getVacancies.Paging.TotalItemsCount === 1){
                $('.js-dashboard-body__sort-results').html(`${getVacancies.Paging.TotalItemsCount} <span>Canlyniad</span>`)
            } else{
                $('.js-dashboard-body__sort-results').html(`${getVacancies.Paging.TotalItemsCount} <span>Canlyniadau</span>`)
            }
        } else {
            if(getVacancies.Paging.TotalItemsCount === 0) {
                $('.js-dashboard-body__sort-results').html('No results')
            } else if(getVacancies.Paging.TotalItemsCount === 1){
                $('.js-dashboard-body__sort-results').html(`${getVacancies.Paging.TotalItemsCount} <span>Result</span>`)
            } else{
                $('.js-dashboard-body__sort-results').html(`${getVacancies.Paging.TotalItemsCount} <span>Results</span>`)
            }
        }

        $('.js-vacancies--list').html('')

        if (getVacanciesArray !== null && getVacanciesArray.length !== 0) {
           
            getVacanciesArray.forEach(function (vacancy, index) {

                const idObject = { 'id': `${vacancy.Id}`, 'attributes': [] }; // Create the 'id' object with an empty 'attributes' array
    
                
                // Create a map to specify the desired order for attributes
                const attributeOrder = {
                    'DBS provided': 1,
                    'Insurance included': 2,
                    'HMRC registered': 3,
                };
    
                for (let i = 0; i < vacancy.AttributeValues.length; i++) {
                    const attributeValue = vacancy.AttributeValues[i];
    
                    if (attributeValue === 'a6164a4f-5420-4894-b95f-b03600fb4683') {
                        idObject.attributes.push('CIW registered');
                    } else if (attributeValue === '4669ce89-e165-450e-8cae-b03600fb4683') {
                        idObject.attributes.push('Cover arranged for A/L');
                    } else if (attributeValue === '178f49bf-3b2e-4f09-8e24-b03600fb4683') {
                        idObject.attributes.push('Cover arranged for sickness');
                    } else if (attributeValue === 'ed29bf38-8a02-4407-a2cc-b03600fb4683') {
                        idObject.attributes.push('DBS provided');
                    } else if (attributeValue === '833e29bf-3e7f-43f3-a1cc-b03600fb4683') {
                        idObject.attributes.push('Food hygiene Training');
                    } else if (attributeValue === '5001c49d-e9ff-4424-9e9a-b03600fb4683') {
                        idObject.attributes.push('HMRC registered');
                    } else if (attributeValue === '51629b51-ed21-4a94-83ef-b03600fb4683') {
                        idObject.attributes.push('Insurance included');
                    } else if (attributeValue === 'a5dafe77-b899-4023-be6e-b03600fb4683') {
                        idObject.attributes.push('IT literate/Digitally confident');
                    } else if (attributeValue === '19a4cbd8-6758-4153-9a81-b03600fb4683') {
                        idObject.attributes.push('Manual handling Training');
                    } else if (attributeValue === '8c78aa0b-a44c-49e2-9489-b03600fb4683') {
                        idObject.attributes.push('Medication Training');
                    } else if (attributeValue === 'e0a430fe-4386-4c3e-951a-b03600fb4683') {
                        idObject.attributes.push('Personal care Training');
                    } else if (attributeValue === '4ccd3547-2005-48cb-9e3b-b03600fb4683') {
                        idObject.attributes.push('Policies/risk assessments/support plans');
                    } else if (attributeValue === '0eb104b4-78fb-42b7-8228-b03600fb4683') {
                        idObject.attributes.push('References available');
                    } else if (attributeValue === 'e2a489fa-fede-42a5-a10e-b03600fb4683') {
                        idObject.attributes.push('Safeguarding Training');
                    } else if (attributeValue === '15088807-111c-47f6-ae0c-b03600fb4683') {
                        idObject.attributes.push('SCW registered');
                    } else if (attributeValue === 'e50cd4a6-0b38-413b-bb7f-b03600fb4683') {
                        idObject.attributes.push('Uniform provided');
                    } else if (attributeValue === 'bd6c201d-538f-476a-a824-b03600fb4683') {
                        idObject.attributes.push('Willing to drive DP user car');
                    } else if (attributeValue === '27d49dbd-14f6-4438-a14d-b03600fb4683') {
                        idObject.attributes.push('Willing to use PA car');
                    }
    
                }
    
                // Sort the attributes based on the desired order
                idObject.attributes.sort((a, b) => {
                    return (attributeOrder[a] || Number.MAX_SAFE_INTEGER) - (attributeOrder[b] || Number.MAX_SAFE_INTEGER);
                });

                 // Keep only the first 3 attributes if there are more than 3
                idObject.attributes = idObject.attributes.slice(0, 3);
    
                if (idObject.attributes.length > 0) {
                    newPADetailsArray.push(idObject); // Add the 'id' object to the result array if there are attributes
                }

                // if (newPADetailsArray.length > 0) {
                //     return newPADetailsArray;
                // } 


                const truncatedDescription = vacancy.Description.substring(0, 100);
           
                if (vacancy.DetailsImageUrl === null || vacancy.DetailsImageUrl === '' || vacancy.DetailsImageUrl === 'https://www.connecttosupport.org/bm' || vacancy.DetailsImageUrl ==='https://www.connecttosupport.org/bm/App_Themes/Default/Images/Default-Catalogue.png') {
                    vacancy.DetailsImageUrl = "/Resources/images/profile-picture-default.jpg"
                    $('.js-imgContainer').css('background-color','#ffffff')
                } else {
                    vacancy.DetailsImageUrl =  vacancy.DetailsImageUrl
                }

                
                if ($.sc.authSettings.isIndividual === true || $.sc.authSettings.isEmployer === true) {
                    $('.js-vacancies--list').append(
                        `
                            <li class="vacancies-tile"">
                                <article aria-labelledby="tile_article${index+1}" class="vacancies-list__content" tabindex="0">
                                    <div class="js-vacancies-tile" data-info-id="${vacancy.Id}">
                                        <div class="circular-image-frame-search">
                                            <img class="contact-image js-imgContainer" src="${vacancy.DetailsImageUrl}" alt=""/>
                                        </div>
                                        <div class="vacancies-list__detail" tabindex="0">
                                            <h2  id="tile_article${index+1}" class="tile-heading">${vacancy.Name}</h2>
                                            <ul class="tile-requirements hidden">
                                            </ul>
                                            <!-- 
                                            <p class="tile-description">${truncatedDescription}...</p>
                                             -->
                                            <p class="tile-rate"><i class="fas fa-money-bill-wave"></i>${vacancy.CustomFieldValue}</p>
                                        </div>
                                    </div>
                                    <button class="star js-star" aria-describedby="tile_article${index+1}" title="Shortlist button" tabindex="0">
                                        <span aria-hidden="true"></span>
                                        <span class="sr-only">Shortlist</span>
                                    </button>
                                    
                                </article>
                            </li>
                        `
                    );
                } else {
                    $('.js-vacancies--list').append(
                        `
                            <li class="vacancies-tile"">
                                <article aria-labelledby="tile_article${index+1}" class="vacancies-list__content" tabindex="0">
                                    <div class="js-vacancies-tile" data-info-id="${vacancy.Id}">
                                        <div class="circular-image-frame-search">
                                            <img class="contact-image js-imgContainer" src="${vacancy.DetailsImageUrl}" alt=""/>
                                        </div>
                                        <div class="vacancies-list__detail" tabindex="0">
                                            <h2  id="tile_article${index+1}" class="tile-heading">${vacancy.Name}</h2>
                                            <ul class="tile-requirements hidden">
                                            </ul>
                                            <!-- 
                                            <p class="tile-description">${truncatedDescription}...</p>
                                             -->
                                            <p class="tile-rate"><i class="fas fa-money-bill-wave"></i>${vacancy.CustomFieldValue}</p>
                                        </div>
                                    </div>                                   
                                </article>
                            </li>
                        `
                    );
                }
          
                

                // <p class="tile-location">${vacancy["Spare 1"]}</p>    			
           
                // Pagination
                if (localStorage.getItem('language') === 'cym') {
                    $('.js-pagination__container').html(
                        `
                            <div class="js-paid-transactions-pagination-container">
                                <div class="js-pagination section hide">
                                    <div class="pcg-pagination" role="navigation" aria-label= "Pagination Bar">
                                        <a class="js-pag-button pag-previous-page lhs pagination-button" href="#" aria-label= "Previous Page">Blaenorol</a> 
                                        <a class="js-pag-button pag-first-page lhs pagination-button" href="#">1</a> 
                                        <a class="js-pag-button pag-current-page lhs pagination-button" href="#"></a>
                                        <a class="js-pag-button pag-last-page lhs pagination-button" href="#"></a> 
                                        <a class="js-pag-button pag-next-page lhs pagination-button" href="#" aria-label= "Next Page">Nesaf</a>
                                    </div>
                                </div>
                            </div>
                        `
                    )
                } else {
                    $('.js-pagination__container').html(
                        `
                            <div class="js-paid-transactions-pagination-container">
                                <div class="js-pagination section hide">
                                    <div class="pcg-pagination" role="navigation" aria-label= "Pagination Bar">
                                        <a class="js-pag-button pag-previous-page lhs pagination-button" href="#" aria-label= "Previous Page">Previous</a> 
                                        <a class="js-pag-button pag-first-page lhs pagination-button" href="#">1</a> 
                                        <a class="js-pag-button pag-current-page lhs pagination-button" href="#"></a>
                                        <a class="js-pag-button pag-last-page lhs pagination-button" href="#"></a> 
                                        <a class="js-pag-button pag-next-page lhs pagination-button" href="#" aria-label= "Next Page">Next</a>
                                    </div>
                                </div>
                            </div>
                        `
                    )
                }

                currentState.pageCount = Math.ceil(getVacancies.Paging.TotalItemsCount / getVacancies.Paging.ItemsPerPage);
                pagination(currentState.page, currentState.pageCount, '.js-pagination__container');



                checkShortlistForStar(vacancy.Id)

                for (let j=0; j<newPADetailsArray.length; j++) {
                    if (newPADetailsArray[j].id === vacancy.Id){

                        for (let k=0; k<newPADetailsArray[j].attributes.length; k++){
                            $(`[data-info-id='${newPADetailsArray[j].id}'] .tile-requirements`).removeClass('hidden')
                            $(`[data-info-id='${newPADetailsArray[j].id}'] .tile-requirements`).append(`
                            <li>${newPADetailsArray[j].attributes[k]}</li>
                            `)
                        }
                        
                    }
                }

                // CTA
                $('.js-pag-button').off().on('click', function(e){

                    overlay();
                    e.preventDefault();
        
                    // Next button
                    if( $(this).hasClass('pag-next-page') ) {
                        if(currentState.page < currentState.pageCount){
                            currentState.page++;		
                        }
        
                    // Previous button
                    } else if( $(this).hasClass('pag-previous-page') ) {
                        if(currentState.page > 1){
                            currentState.page--;		
                        }
        
                    // Back to first page
                    } else if( $(this).hasClass('pag-first-page') ) {
                        currentState.page = 1;
        
                    // Last page clicked
                    } else if( $(this).hasClass('pag-last-page') ) {
                        currentState.page = currentState.pageCount;
        
                    // Page plus 1
                    } else if( $(this).hasClass('js-pag-plus1') ) {
                        currentState.page++;
        
                    // Page plus 2
                    } else if( $(this).hasClass('js-pag-plus2') ) {
                        currentState.page = currentState.page + 2;
        
                    // Page plus 3
                    } else if( $(this).hasClass('js-pag-plus3') ) {
                        currentState.page = currentState.page + 3;
        
                    // Page minus 1
                    } else if( $(this).hasClass('js-pag-minus1') ) {
                        currentState.page--;
        
                    // Page minus 2
                    } else if( $(this).hasClass('js-pag-minus2') ) {
                        currentState.page = currentState.page - 2;
        
                    // Page minus 3
                    } else if( $(this).hasClass('js-pag-minus3') ) {
                        currentState.page = currentState.page - 3;
        
                    // Page minus 3
                    } else if( $(this).hasClass('js-pag-minus3') ) {
                        currentState.page = currentState.page - 3;
                    }

                    //createPage();
                    createMyVacanciesPanel();
                });
               
            });

            
            var getPAFromList = document.querySelectorAll(".js-vacancies-tile");

            getPAFromList.forEach(function(pa) {
                pa.addEventListener("click", function() {
                    // Redirect to the desired URL
                    window.location.href = "/s4s/CustomPage/Index/" + Urls.pa_profile + "?q="+ `${this.getAttribute('data-info-id')}`;
                });
            });


        } else if (getVacanciesArray.length === 0) {
            $('.js-pagination__container').html('')
        }

        if (getVacanciesArray == null) {
            $('.dashboard-progress__bar--progress').html('50% <span></span>')
            $('.dashboard-progress__bar--progress').css('width', '50%')
        } else {
            $('.dashboard-progress__bar--progress span').css('width', '100%')
            $('.dashboard-progress__bar--progress').html('<span></span>')
        }


        $('.js-star').click(function(){
            $(this).toggleClass('activeStartButton');
            const shortlisdId = $(this).parent().children().eq(0).attr('data-info-id');
            const shortlistSrc = $(this).closest('.vacancies-list__content').find('.contact-image').attr('src');
            const shortlistName = $(this).closest('.vacancies-list__content').find('.tile-heading').text();
            const shortlistDescription = $(this).closest('.vacancies-list__content').find('.tile-description').text();
            const shortlistRate = $(this).closest('.vacancies-list__content').find('.tile-rate').text();
            const shortlistRequirements = $(this).closest('.vacancies-list__content').find('.tile-requirements li')
            var shortlistRequirementsArray = []

            if (shortlistRequirements) {
                for (let i=0; i<shortlistRequirements.length; i++){
                    shortlistRequirementsArray.push(shortlistRequirements[i].innerText)
                }
            }
            
            // Step 1: Retrieve the existing data from localStorage
            const existingNestedObjectsJSON = localStorage.getItem($.sc.authSettings.id);
            const existingNestedObjectsArray = existingNestedObjectsJSON  ? JSON.parse(existingNestedObjectsJSON) : [];

            // Step 2: Create a new nested object
            const newNestedObject = {
                id: shortlisdId , 
                user: {
                    name: `${shortlistName}`,
                    src: `${shortlistSrc}`,
                    description: `${shortlistDescription}`,
                    rate: `${shortlistRate}`,
                    requirements: shortlistRequirementsArray      
                    }
            };


            // Step 3: Add the new nested object to the array
            existingNestedObjectsArray.push(newNestedObject);

            // Step 4: Convert the updated array to JSON
            const updatedNestedObjectsJSON = JSON.stringify(existingNestedObjectsArray);

            // Step 5: Store the updated data back in localStorage
            localStorage.setItem($.sc.authSettings.id, updatedNestedObjectsJSON);

            const notificationContainer = document.querySelector('.js-shortlist-notification-container');
            const notificationMessages = document.querySelector('.js-shortlist-notification-message')

            if (!$(this).hasClass('activeStartButton')) {
               
                // Step 1: Retrieve the existing data from localStorage
                const existingNestedObjectsJSON = localStorage.getItem($.sc.authSettings.id);
                const existingNestedObjectsArray = existingNestedObjectsJSON ? JSON.parse(existingNestedObjectsJSON) : [];

                // Function to retrieve a nested object by its id
                function getNestedObjectById(id) {
                    return existingNestedObjectsArray.find(nestedObject => nestedObject.id === id);
                }

                // Function to delete a nested object by its id
                function deleteNestedObjectById(id) {
                    const updatedNestedObjectsArray = existingNestedObjectsArray.filter(nestedObject => nestedObject.id !== id);

                    if (updatedNestedObjectsArray.length !== existingNestedObjectsArray.length) {
                        // Update localStorage with the modified array
                        const updatedNestedObjectsJSON = JSON.stringify(updatedNestedObjectsArray);
                        localStorage.setItem($.sc.authSettings.id, updatedNestedObjectsJSON);
                        
                    } 
                }


                // Example usage
                const desiredIdToDelete = shortlisdId;
                const nestedObjectToDelete = getNestedObjectById(desiredIdToDelete);

                if (nestedObjectToDelete) {
                    deleteNestedObjectById(desiredIdToDelete);
                } 

                if (notificationContainer) {
                    // notificationMessages.innerText = 'Removed from My Shortlist'
                    if ( localStorage.getItem('language') === 'cym') {  
                        notificationMessages.innerText = `Tynnu i Ffwrdd o Fy Rhestr Fer`
                    } else {
                        notificationMessages.innerText = 'Removed from My Shortlist'
                    }
                    // Display the notification
                    notificationContainer.style.display = 'flex';

                    // Hide the notification after 2 seconds
                    setTimeout(() => {
                        notificationContainer.style.display = 'none';
                    }, 2000);
                }

                
            } else {

                if (notificationContainer) {
                    // notificationMessages.innerText = 'Added to My Shortlist'
                    if ( localStorage.getItem('language') === 'cym') {  
                        notificationMessages.innerText = `Ychwanegu at Fy Rhestr Fer`
                    } else {
                        notificationMessages.innerText = 'Added to My Shortlist'
                    }
                    // Display the notification
                    notificationContainer.style.display = 'flex';

                    // Hide the notification after 2 seconds
                    setTimeout(() => {
                        notificationContainer.style.display = 'none';
                    }, 2000);
                }
                
            }

            $('#js-header-inner').css('overflow','unset')
            setTimeout(() => {
                $('#js-header-inner').css('overflow','hidden')
            }, 2100);
        });        

        findPATranslation();

    }

    function checkShortlistForStar(vacancyid) {

        // Replace 'yourLocalStorageKey' with the actual key used in your local storage
        const localStorageKey = $.sc.authSettings.id;

        // Replace 'desiredId' with the ID you are looking for
        const desiredId = vacancyid;

        // Step 1: Retrieve data from local storage
        const dataFromLocalStorage = localStorage.getItem(localStorageKey);

        if (dataFromLocalStorage) {
            // Step 2: Parse the retrieved data into a JavaScript object
            const parsedData = JSON.parse(dataFromLocalStorage);

            // Step 3: Traverse the object to find the nested object with the specified ID
            const isObjectFound = findNestedObjectById(parsedData, desiredId);

            if (isObjectFound) {
                var itemFromLS =  $('[data-info-id]').filter(`[data-info-id='${vacancyid}']`);
                itemFromLS.next().addClass('activeStartButton')
            } 
        } 

        // Function to recursively search for an object with the desired ID
        function findNestedObjectById(object, id) {
            if (object.id === id) {
                return true;
            }

            for (const key in object) {
                if (typeof object[key] === 'object') {
                    const isFound = findNestedObjectById(object[key], id);
                    if (isFound) {
                        return true;
                    }
                }
            }

            return false;
        }


    }
   
    

    var Attributes = {
        init: function () {
            this.adjustDom();
            this.bindUIActions();
            this.unload();
        },

        adjustDom: function () {
            createPage();
        },

        bindUIActions: function () {

            //Number of selected filters
           
  
            function updateFilterCount(parentId) {
                var selectedFilters = document.querySelectorAll(`#${parentId} .js-attr-btn.selected`);
                var filterCount = selectedFilters.length;
                var filterCountElements = document.querySelectorAll('.active-filter .filterCount');
        
                filterCountElements.forEach(function(element) {
                    if (filterCount === 0) {
                        element.style.display = 'none'; // Hide the count when no filters are selected
                    } else {
                        element.style.display = 'inline'; // Show the count when filters are selected
                        element.textContent = `(${filterCount})`;
                    }
                });
            }


            $('body').on('click', '.js-attr-btn', function () {
                const thisAttribute = $(this).attr('data-attr');
                const parentId = $(this).parent().parent().attr('id');

                if ($(this).hasClass('selected')) {
                    currentState.attributes = currentState.attributes.replace(thisAttribute, '');
                    $(this).removeClass('selected');
                    $(this).children().eq(0).html('')
                } else {
                    currentState.attributes += thisAttribute;
                    $(this).addClass('selected');
                    $(this).children().eq(0).html('<i class="fa fa-check"></i>')
                }

                updateFilterCount(parentId)

                createMyVacanciesPanel();
            });

            const filterDropdowns = [
                { buttonId: 'filterLocation', dropdownId: 'filterLocationDropdown' },
                { buttonId: 'filterAvailability', dropdownId: 'filterAvailabilityDropdown' },
                { buttonId: 'filterRequirements', dropdownId: 'filterRequirementsDropdown' },
                { buttonId: 'filterLanguages', dropdownId: 'filterLanguagesDropdown' },
                { buttonId: 'filterProviderType', dropdownId: 'filterProviderTypeDropdown' },
                { buttonId: 'filterHourlyRate', dropdownId: 'filterHourlyRateDropdown' }

              ];
              
              function setupFilterDropdown(buttonId, dropdownId) {
                const button = document.getElementById(buttonId);
                const dropdown = document.getElementById(dropdownId);
                
                button.addEventListener('click', () => {
                  filterDropdowns.forEach(item => {
                    const otherButton = document.getElementById(item.buttonId);
                    const otherDropdown = document.getElementById(item.dropdownId);
                    
                    if (buttonId === item.buttonId) {
                      dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
                      button.classList.toggle('active-filter');
                    } else {
                      otherDropdown.style.display = 'none';
                      otherButton.classList.remove('active-filter');
                    }
                  });
                });
              }
              
              filterDropdowns.forEach(({ buttonId, dropdownId }) => {
                setupFilterDropdown(buttonId, dropdownId);
              });
              
              const modalButtons = [
                { buttonId: "openModalBtnLocation", modalId: "modal" },
                { buttonId: "openModalBtnRequirements", modalId: "modal" },
                { buttonId: "openModalBtnAvailability", modalId: "modal" },
                { buttonId: "openModalBtnLanguages", modalId: "modal" },
                { buttonId: "openModalBtnProviderType", modalId: "modal" },
                { buttonId: "openModalBtnHourlyRate", modalId: "modal" }

              ];
              
              const closeModalBtn = document.getElementById("closeModalBtn");
              
              function closeDropdownsAndRemoveActiveFilter() {
                filterDropdowns.forEach(({ dropdownId, buttonId }) => {
                  const dropdown = document.getElementById(dropdownId);
                  const button = document.getElementById(buttonId);
                  
                  dropdown.style.display = 'none';
                  button.classList.remove('active-filter');
                });
              }
              
              function toggleModal(modalId) {
                const modal = document.getElementById(modalId);
                const modalOverlay = document.getElementById("modalOverlay");
                const filterSection = document.getElementById("dashboard-body__filter-section");
                const listSection = document.getElementById("dashboard-body__list-section");
              
                if (modal.style.display === "flex") {
                  modal.style.display = "none";
                  modalOverlay.style.display = "none";
                  filterSection.style.display= "flex";
                  listSection.style.display= "block";
                  closeDropdownsAndRemoveActiveFilter();
                } else {
                  modal.style.display = "flex";
                  modalOverlay.style.display = "flex";
                  filterSection.style.display= "none";
                  listSection.style.display= "none";
                }
              }
              
              for (const { buttonId, modalId } of modalButtons) {
                const openModalBtn = document.getElementById(buttonId);
                const modal = document.getElementById(modalId);
              
                // Click event listener
                openModalBtn.addEventListener("click", () => {
                  toggleModal(modalId);
                  closeDropdownsAndRemoveActiveFilter();
                  modal.focus()
                });
              
                // Enter key event listener
                openModalBtn.addEventListener("keydown", (event) => {
                  if (event.key === "Enter") {
                    toggleModal(modalId);
                    closeDropdownsAndRemoveActiveFilter();
                    modal.focus()
                  }
                });
                  
              }

            // Close dropdown menu on 'Esc' key press
            document.body.addEventListener("keydown", (event) => {
                if (event.key === "Escape") {
                    closeDropdownsAndRemoveActiveFilter();
                    modal.focus()
                }
            });
              
              modalOverlay.addEventListener("click", () => {
                for (const { modalId } of modalButtons) {
                  const modal = document.getElementById(modalId);
                  if (modal.style.display === "flex") {
                    toggleModal(modalId);
                  }
                }
              });
              
              closeModalBtn.addEventListener("click", () => {
                for (const { modalId } of modalButtons) {
                  const modal = document.getElementById(modalId);
                  if (modal.style.display === "flex") {
                    toggleModal(modalId);
                  }
                }
              });
              
              // Enter key event listener for closeModalBtn (if needed)
              closeModalBtn.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                  for (const { modalId } of modalButtons) {
                    const modal = document.getElementById(modalId);
                    if (modal.style.display === "flex") {
                      toggleModal(modalId);
                    }
                  }
                }
              });
                 

              //Sorting
              $('#js-sorting-events').change(function(){
				
				if ( $('#js-sorting-events').val() === 'js-sort-name-a-z' ) {

                    currentState.SortType = 'asc'
                    createMyVacanciesPanel();

				} else if ( $('#js-sorting-events').val() === 'js-sort-name-z-a' ) {
          
                    currentState.SortType = 'desc'
                    createMyVacanciesPanel();

				} else {
                 
                    currentState.SortType = ''
                    createMyVacanciesPanel();
				}
                
			});


            $('#js-sorting-events').click(function () {
                $('#js-sorting-events option').each(function () {
                    if (localStorage.getItem('language') === 'cym') {
                        if ($(this).text() === "Name (A - Z)") {
                            $(this).text('Enw (A - Y)');
                        }
            
                        if ($(this).text() === "Name (Z - A)") {
                            $(this).text('Enw (Y - A)');
                        }
                    }
                });
            });

            $('#js-sorting-events').keydown(function (e) {
                if (e.keyCode === 13) { // Check for Enter key press
                    $('#js-sorting-events').click(); // Trigger a click event on the select element
                }
            });

            // $(document).keydown(function (e) {
            //     if (e.keyCode === 9) { // Check for Tab key press
            //         var focusedElement = document.activeElement;
            //         console.log("Focused element:", focusedElement);
            //     }
            // });
            


                
                
            findPATranslation()
                       

        },

        unload: function () {},
    };

    Attributes.init();
})();